<template>
  <v-container fluid class="pa-0 ma-0">
    <v-nav :page="page"/>
    <div class="main-content">
      <div class="">
        <v-layout class="grey lighten-2">
          <v-flex class="toolbar">
            <div class="d-inline-block pl-4 pt-4">
              <h2>{{ title }}</h2>
            </div>
          </v-flex>
          <v-flex>
            <div class="actions">
              <slot name="actions"/>
            </div>
          </v-flex>
          <v-flex sm3>
              <CreateAccounts/>
              <div class="d-inline-block ml-2" v-if="$can({ company: 'switch' })"/>
              <div class="d-inline-block mr-3">Viewing as</div>
              <change-company/>
          </v-flex>
        </v-layout>
        <main>
          <div v-if="hasToolbarSlot">
            <v-toolbar flat dark class="mb-2">
              <slot name="toolbar"/>
            </v-toolbar>
          </div>
          <div class="ml-4 mr-4">
          <slot/>
          </div>
        </main>
      </div>
    </div>
  </v-container>
</template>

<script>
import VNav from '../components/Nav/Nav'
import CreateAccounts from '@/components/Account/CreateAccounts'
import ChangeCompany from '@/components/ChangeCompany'
import CurrentSession from '@/mixins/CurrentSession'

export default {
  name: 'DefaultLayout',
  props: {
    /**
     * The title of the page
     */
    page: String,
    /**
     * Breadcrumbs to be displayed on the top of the page
     */
    breadcrumbs: {
      type: Array,
      default: () => {
        return [
          { to: '/', text: 'Imbellus Admin' },
          { disabled: true }
        ]
      }
    },
    title: {
      type: String,
      default: null
    }
  },
  mixins: [CurrentSession],
  components: {
    VNav,
    ChangeCompany,
    CreateAccounts
  },
  computed: {
    hasToolbarSlot () {
      return this.$slots.toolbar !== undefined
    }
  }
}
</script>

<style lang="sass">
.main-content
  margin-left: 70px

a
  text-decoration: none !important

.toolbar
  .viewing-as
    font-size: 16px
</style>
